import { render, staticRenderFns } from "./platformCommission.vue?vue&type=template&id=5d3a59c0&scoped=true"
import script from "./platformCommission.vue?vue&type=script&lang=js"
export * from "./platformCommission.vue?vue&type=script&lang=js"
import style0 from "./platformCommission.vue?vue&type=style&index=0&id=5d3a59c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3a59c0",
  null
  
)

export default component.exports